<div class="spin-wheel-game">
  <!-- Header -->
  <div class="game-header">
    <span class="question-counter">
      <span class="current">{{ getQuestionNum() | arabicNumber:currLang }}</span>
      <span class="separator">/</span>
      <span class="total">{{ getTotalQuestions() | arabicNumber:currLang }}</span>
    </span>
    <span class="game-title">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="vertical-align: middle; margin-right: 4px;">
        <circle cx="12" cy="12" r="11" stroke="#FFD700" stroke-width="2" fill="none"/>
        <circle cx="12" cy="12" r="3" fill="#FFD700"/>
        <line x1="12" y1="1" x2="12" y2="5" stroke="#FFD700" stroke-width="2"/>
        <line x1="12" y1="19" x2="12" y2="23" stroke="#FFD700" stroke-width="2"/>
        <line x1="1" y1="12" x2="5" y2="12" stroke="#FFD700" stroke-width="2"/>
        <line x1="19" y1="12" x2="23" y2="12" stroke="#FFD700" stroke-width="2"/>
      </svg>
      {{ currLang === 'ar' ? 'أدر العجلة' : 'Spin the Wheel' }}
    </span>
    <div class="header-actions">
      <app-game-sound-control></app-game-sound-control>
      <button class="header-action-btn help-btn" (click)="showInfo = true">
        <span class="help-icon">?</span>
      </button>
    </div>
  </div>
  <app-game-info-modal *ngIf="showInfo" [gameType]="'spin_wheel'" (close)="showInfo = false"></app-game-info-modal>

  <!-- Ready to spin -->
  <div class="phase-spin" *ngIf="internalPhase === 'ready' || internalPhase === 'spinning'">
    <app-spin-wheel #spinWheel
      [students]="wheelStudents"
      [currLang]="currLang"
      (studentSelected)="onStudentSelected($event)">
    </app-spin-wheel>

    <button class="spin-btn" *ngIf="internalPhase === 'ready'"
            (click)="onSpin(); spinWheel.spin()">
      {{ currLang === 'ar' ? 'أدر!' : 'SPIN!' }}
    </button>

    <div class="spinning-text" *ngIf="internalPhase === 'spinning'">
      {{ currLang === 'ar' ? 'جاري الدوران...' : 'Spinning...' }}
    </div>
  </div>

  <!-- Student picked -->
  <div class="phase-student" *ngIf="internalPhase === 'student-picked'">
    <app-student-spotlight
      [student]="selectedStudent"
      [currLang]="currLang"
      [label]="currLang === 'ar' ? 'يجيب على السؤال!' : 'Answers the question!'">
    </app-student-spotlight>
  </div>

  <!-- Question phase -->
  <div class="phase-question" *ngIf="internalPhase === 'question' && currentQuestion">
    <div class="question-top-row">
      <div class="answering-student">
        <app-student-avatar [student]="selectedStudent" [size]="52" [active]="true"></app-student-avatar>
        <span class="student-name">{{ getStudentName() }}</span>
      </div>
      <app-quiz-timer [value]="timerValue" [max]="session?.config?.timePerQuestion || 30" [currLang]="currLang"></app-quiz-timer>
    </div>

    <app-question-card
      [question]="currentQuestion"
      [selectedOption]="selectedOption"
      (optionSelected)="selectOption($event)">
    </app-question-card>

    <button class="submit-btn" [class.active]="selectedOption" [disabled]="!selectedOption" (click)="submitAnswer()">
      {{ currLang === 'ar' ? 'تأكيد' : 'Submit' }}
    </button>
  </div>

  <!-- Time's up / Missed -->
  <div class="phase-result" *ngIf="internalPhase === 'missed'">
    <div class="result-flash missed">
      <span class="result-icon">&#9200;</span>
      <span class="result-text">{{ currLang === 'ar' ? 'انتهى الوقت!' : "Time's Up!" }}</span>
      <span class="result-sub">{{ currLang === 'ar' ? 'لم يتم الإجابة' : 'No answer given' }}</span>
    </div>
  </div>

  <!-- Result flash -->
  <div class="phase-result" *ngIf="internalPhase === 'result' && lastResult">
    <div class="result-flash" [class.correct]="lastResult.isCorrect" [class.incorrect]="!lastResult.isCorrect">
      <span class="result-icon">{{ lastResult.isCorrect ? '&#10004;' : '&#10008;' }}</span>
      <span class="result-text">{{ lastResult.isCorrect ? (currLang === 'ar' ? 'صحيح!' : 'Correct!') : (currLang === 'ar' ? 'خطأ' : 'Incorrect') }}</span>
      <span class="result-xp" *ngIf="lastResult.xpEarned > 0">+{{ lastResult.xpEarned | arabicNumber:currLang }} XP</span>
    </div>
  </div>
</div>
